import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-search-guidelines',
    templateUrl: './search-guidelines.component.html',
    styleUrls: ['./search-guidelines.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchGuidelinesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  preventDefault(e) {
    e.preventDefault();
  }

}
